export function timeRemaining(targetDate: string) {
  if (!targetDate || targetDate === '') {
    return { text: 'ไม่ระบุเวลา', months: 0, days: 0, hours: 0 }
  }

  const now = new Date()
  const endDate = new Date(targetDate)

  let diff = endDate.getTime() - now.getTime()
  if (diff <= 0) {
    return {
      text: 'หมดเวลา',
      isPast: true,
      months: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    }
  }

  const months = Math.floor(diff / (1000 * 60 * 60 * 24 * 30))
  diff -= months * (1000 * 60 * 60 * 24 * 30)
  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  diff -= days * (1000 * 60 * 60 * 24)
  const hours = Math.floor(diff / (1000 * 60 * 60))

  diff -= hours * (1000 * 60 * 60)
  const minutes = Math.max(Math.floor(diff / (1000 * 60)), 0)

  diff -= minutes * (1000 * 60)
  const seconds = Math.max(Math.floor(diff / 1000), 0)

  return {
    isPast: false,
    months: months,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    text: `${months} เดือน ${days} วัน ${hours} ชั่วโมง`,
  }
}

export function convertToISODateString(date?: Date) {
  if (!date) {
    return undefined
  }

  const isoDate = date.toISOString()
  return isoDate
}

export function isActive(startDate?: Date, endDate?: Date) {
  if (!startDate || !endDate) {
    return false
  }

  const now = new Date()
  return now >= startDate && now <= endDate
}
